import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = defineStore('ui', () => {
  // State
  const loading = ref(false)
  const notifications = ref([])
  const modals = ref({})
  const sidebar = ref({
    isOpen: false,
    collapsed: false
  })
  const theme = ref('light')
  
  // Actions
  const setLoading = (isLoading) => {
    loading.value = isLoading
  }
  
  const showNotification = (notification) => {
    const id = Date.now() + Math.random()
    const newNotification = {
      id,
      type: notification.type || 'info',
      title: notification.title || '',
      message: notification.message || '',
      duration: notification.duration || 5000
    }
    
    notifications.value.push(newNotification)
    
    // Auto remove notification after duration
    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, newNotification.duration)
    }
  }
  
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }
  
  const clearNotifications = () => {
    notifications.value = []
  }
  
  const toggleModal = (modalName, isOpen = null) => {
    if (isOpen !== null) {
      modals.value[modalName] = isOpen
    } else {
      modals.value[modalName] = !modals.value[modalName]
    }
  }
  
  const closeAllModals = () => {
    Object.keys(modals.value).forEach(key => {
      modals.value[key] = false
    })
  }
  
  const toggleSidebar = () => {
    sidebar.value.isOpen = !sidebar.value.isOpen
  }
  
  const setSidebarOpen = (isOpen) => {
    sidebar.value.isOpen = isOpen
  }
  
  const toggleSidebarCollapsed = () => {
    sidebar.value.collapsed = !sidebar.value.collapsed
  }
  
  const setTheme = (newTheme) => {
    theme.value = newTheme
    localStorage.setItem('theme', newTheme)
    
    // Apply theme to document
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
  
  const initializeTheme = () => {
    const savedTheme = localStorage.getItem('theme') || 'light'
    setTheme(savedTheme)
  }
  
  return {
    // State
    loading,
    notifications,
    modals,
    sidebar,
    theme,
    
    // Actions
    setLoading,
    showNotification,
    removeNotification,
    clearNotifications,
    toggleModal,
    closeAllModals,
    toggleSidebar,
    setSidebarOpen,
    toggleSidebarCollapsed,
    setTheme,
    initializeTheme
  }
})
